import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["max-length"]
const _hoisted_2 = ["required", "placeholder"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_maska = _resolveDirective("maska")

  return (_openBlock(), _createElementBlock("y-input-wrapper", {
    "max-length": $props.maxLength ?? 0
  }, [
    _createElementVNode("label", {
      slot: "label",
      for: $setup.randomId
    }, _toDisplayString($props.label), 1 /* TEXT */),
    _withDirectives(_createElementVNode("input", {
      id: $setup.randomId,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.value) = $event)),
      required: $props.required,
      class: _normalizeClass(['order-form__input-text', $props.additionalClasses].join(' ')),
      placeholder: $props.placeholder,
      autocomplete: "off"
    }, null, 10 /* CLASS, PROPS */, _hoisted_2), [
      [_vModelText, $setup.value],
      [_directive_maska, $props.mask]
    ])
  ], 8 /* PROPS */, _hoisted_1))
}